const HUB_TABS = ["overview", "training", "activity", "development", "health"]
const HEALTH_DESTINATIONS = ["sleepSeconds", "heartRate", "steps", "activeEnergyKilocalories", "totalEnergyKilocalories", "distanceMeters", "weightKilograms", "body", "activities", "settings"]

export function customerHubTab(query = {}) {
  if (HUB_TABS.includes(query.tab)) return query.tab
  if (query.health === "1") return "health"
  return query.updated === "true" || query.refresh ? "training" : "overview"
}

export function customerHubHealthMetric(value) { return HEALTH_DESTINATIONS.includes(value) ? value : "" }

export function customerHubHealthLocation(metric = "", date = "") {
  const query = { tab: "health", mode: "own" }
  const key = customerHubHealthMetric(metric), day = customerHubDate(date)
  if (key) query.metric = key
  if (day) query.date = day
  return { path: "/workout/hub", query }
}

export function customerHubDate(value) {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return ""
  const date = new Date(`${value}T12:00:00Z`)
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? value : ""
}

export function customerHubActivityLocation(date) {
  const query = { tab: "activity", mode: "own" }
  const validDate = customerHubDate(date)
  if (validDate) query.date = validDate
  return { path: "/workout/hub", query }
}
